import React from 'react';
import {useWindowSize} from '../../../../../general';
import {Netopia} from './Netopia';
import {FormattedMessage} from 'react-intl';

export const FooterInfo = () => {
    const basePath = '/static/frontend/Eadesignro/desktop/ro_RO/images/';
    const basePathMobile = '/static/frontend/Eadesignro/mobile/ro_RO/images/';

    const handleClick = (e) => {
        e.preventDefault();
        window.open('http://www.shopmania.ro/site/magazialucostica.ro', '_blank');
    };

    return (
        <div className={'flex flex-col xl:flex-row justify-around items-center xl:items-start gap-5'}>
            <div className={'flex flex-col items-center xl:items-start gap-5'}>
                <div className={'flex flex-col xl:flex-row justify-center items-center gap-5'}>
                    <div className={'flex flex-row justify-center items-center gap-5'}>
                        <img className={'h-[50px]'} src={`${basePath}eu.png`} alt=""/>
                        <img className={'h-[50px]'} src={`${basePath}ro.png`} alt=""/>
                        <img className={'h-[50px]'} src={`${basePath}euro.png`} alt=""/>
                    </div>
                    <div className={'flex flex-row justify-center items-center gap-5'}>
                        <img className={'h-[50px]'} src={`${basePath}europeanbank.png`} alt=""/>
                    </div>
                </div>
                <p className={'react-css flex flex-col font-bold text-center xl:text-left text-text-gray font-nunito text-xs'}>
                    <span>
                        <FormattedMessage id="footer_operational_program" />
                    </span>
                    <span>
                        <FormattedMessage id="footer_priority_axis" />
                    </span>
                    <span>
                        <FormattedMessage id="footer_invest_future" />
                    </span>
                    <span>
                        <FormattedMessage id="footer_company" />
                    </span>
                </p>
            </div>
            <div className={'flex flex-col items-center xl:items-start gap-5'}>
                <div className={'flex flex-row justify-start items-center gap-5'}>
                    <a href="https://www.armo.org.ro/membri/magazia-lu-costica/" target="_blank">
                        <img className={'h-[50px]'} src={`${basePath}armo.png`} alt="armo"/>
                    </a>
                    <a>
                        <img className={'h-[50px]'} src={`${basePath}SEAP.png`} alt="seap"/>
                    </a>
                    <a title="Compari.ro - ghid autentic de shopping" href="http://www.compari.ro/" rel="nofollow">
                        <img className={'h-[50px]'} src={`${basePath}comparibadge.png`}
                            alt="Compari.ro - ghid autentic de shopping"/>
                    </a>
                </div>
                <Netopia />
            </div>
            
            <div className="row">
                <div className="react-css flex flex-col font-bold 
                    text-center xl:text-left text-cards-bg font-nunito text-lg xl:text-lg">
                    <span><FormattedMessage id="footer_we_are_present" /></span>
                    <div className={'flex flex-row gap-5 justify-center xl:justify-start'}>
                        <a href="http://www.compari.ro/" rel="nofollow"
                           title="Ghidul tau autentic de shopping."
                           target="_blank">
                            <img className={'h-[50px]'} src={`${basePath}compari.png`}
                                 alt="Ghidul tau autentic de shopping."/>
                        </a>
                        <a href="http://www.shopmania.ro/"
                           rel="noopener noreferrer"
                           title="Viziteaza magazinul Magazia Lu' Costică pe ShopMania"
                           onClick={handleClick}
                           onKeyPress={(e) => e.key === 'Enter' && handleClick(e)}>
                            <img
                                className="h-[50px]"
                                src={`${basePath}shopmania.jpg`}
                                alt="Viziteaza magazinul Magazia Lu' Costică pe ShopMania"
                            />
                        </a>
                    </div>
                    <span><FormattedMessage id="footer_alternative_dispute" /> </span>
                    <div className={'flex flex-row gap-5 justify-center xl:justify-start'}>
                        <a className="anpc-sal" rel="nofollow"
                           href="https://anpc.ro/ce-este-sal/"
                           title="Solutionarea alternativa a litigiilor"
                           target="_blank">
                            <img className={'h-[50px]'} src={`${basePath}SAL.svg`}
                                 alt="Solutionarea alternativa a litigiilor"/>
                        </a>
                        <a className="anpc-sol" rel="nofollow"
                           href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
                           title="Solutionarea online a litigiilor"
                           target="_blank">
                            <img className={'h-[50px]'} src={`${basePath}SOL.svg`}
                                 alt="Solutionarea online a litigiilor"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};